import _ from "lodash";
import { createReducer } from "../utils";
import {
  CURRENT_USER_REQUEST,
  CURRENT_USER_SUCCESS,
  CURRENT_USER_FAILURE,
  CURRENT_USER_SAVE_REQUEST,
  CURRENT_USER_SAVE_SUCCESS,
  CURRENT_USER_SAVE_FAILURE,
  CURRENT_USER_UPDATE_AVATAR,
  CURRENT_USER_RESET,
  CURRENT_USER_NEW_NOTIFICATIONS,
  CURRENT_USER_CLEAR_NOTIFICATIONS,
} from '../constants';

const initialState = {
  data: null,
  isFetching: false,
  unreadNotifications: [],
};

export default createReducer(initialState, {
  [CURRENT_USER_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      data: payload.user,
      isFetching: false
    });
  },
  [CURRENT_USER_REQUEST]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true
    });
  },
  [CURRENT_USER_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: false
    });
  },
  [CURRENT_USER_SAVE_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      data: payload.data,
      isFetching: false
    });
  },
  [CURRENT_USER_SAVE_REQUEST]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true
    });
  },
  [CURRENT_USER_SAVE_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: false
    });
  },
  [CURRENT_USER_UPDATE_AVATAR]: (state, payload) => {
    let data = state.data;
    _.extend(data, {
      avatar_uri: payload.avatarUri,
    });
    return Object.assign({}, state, {
      data,
    });
  },
  [CURRENT_USER_RESET]: (state) => {
    return Object.assign({}, state, {
      data: null,
    });
  },
  [CURRENT_USER_NEW_NOTIFICATIONS]: (state, payload) => {
    const unreadNotifications = Array.from(new Set(payload.unreadNotifications));
    return Object.assign({}, state, {
      unreadNotifications,
    });
  },
  [CURRENT_USER_CLEAR_NOTIFICATIONS]: (state) => {
    return Object.assign({}, state, {
      unreadNotifications: [],
    });
  },
});
